import { ApiResponse, fetcher, postFetcher } from './base-api';
import {
  BlogReviewListResponse,
  PlusReviewListParams,
  PlusReviewListResponse,
  PostReviewBlockParams,
  PostReviewDeleteParams,
  PostReviewLikeParams,
  PostReviewReportParams,
  ReviewResponse,
} from './types/review.type';

/** 리뷰 작성/수정 업로드용 timeout (ms) */
const REVIEW_UPLOAD_TIMEOUT_MS = 60_000;

export const postReviewWrite = async (
  academyId: string,
  formData: FormData,
) => {
  return postFetcher<ReviewResponse>(`/review/write/${academyId}`, formData, {
    timeout: REVIEW_UPLOAD_TIMEOUT_MS,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const postReviewEdit = async (reviewId: number, formData: FormData) => {
  return postFetcher<ReviewResponse>(`/review/edit/${reviewId}`, formData, {
    timeout: REVIEW_UPLOAD_TIMEOUT_MS,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const postReviewDelete = async (
  reviewId: number,
  params: PostReviewDeleteParams,
) => {
  return postFetcher<ReviewResponse>(`/review/delete/${reviewId}`, params);
};

export const postReviewLike = async (
  reviewId: number,
  params: PostReviewLikeParams,
) => {
  return postFetcher<ReviewResponse>(`/review/like/${reviewId}`, params);
};

export const postReviewBlock = async (
  reviewId: number,
  params: PostReviewBlockParams,
) => {
  return postFetcher<ReviewResponse>(`/review/block/${reviewId}`, params);
};

export const postReviewReport = async (
  reviewId: number,
  params: PostReviewReportParams,
) => {
  return postFetcher<ReviewResponse>(`/review/report/${reviewId}`, params);
};

export const getReviewList = async (
  academyId: string,
  params: PlusReviewListParams,
): Promise<ApiResponse<PlusReviewListResponse>> => {
  return fetcher<PlusReviewListResponse>(`/review/list/${academyId}`, {
    params,
  });
};

export const getBlogReviewList = async (
  academyId: string,
  page: number,
  limit: number,
): Promise<ApiResponse<BlogReviewListResponse>> => {
  return fetcher<BlogReviewListResponse>(`/blog-review/list/${academyId}`, {
    params: { page, limit },
  });
};
